module.exports = __webpack_public_path__ + "static/media/exwife-quote.a7792885.mp3";